import { render } from "./InsuranceSection.vue?vue&type=template&id=39605f86"
import script from "./InsuranceSection.vue?vue&type=script&lang=js"
export * from "./InsuranceSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__